import React from 'react'
import ReactCursorPosition from 'react-cursor-position'
import cx from 'classnames'

import PageLink from '@/link.js'
import Image from '@/image.js'

const BrandImage = (props) => {
  const {
    position: {
      x = 0,
      y = 0
    } = {},
    isActive = false,
    cat
  } = props
  return (
    <div>
      <div className={cx('brand__ticker-image abs bottom x y', {
        'is-active': isActive && y > 0
      })} style={{
        transform: `translate(${(x * 0.5)}px, ${y}px)`
      }}>
        {cat.imageId && (<Image imageId={cat.imageId} alt={cat.title} width={500} />)}
      </div>
      <h3 className={cx('h1-display h1 rel z1 px1 my0 mx05', {
        'is-active': isActive
      })}>
        <PageLink to='/whats-in-store' state={{ category: cat.title }} className='abs top left x y' />{cat.title}</h3>
    </div>
  )
}

const BrandTicker = ({ content }) => {
  return (
    <div className='x brand__ticker-wrapper p1'>
      <div className='brand__row rel f jcb aic'>
        <div className='brand__row-inner f jcb aic'>
          {content.brandsCategories.map((cat, i) => (
            <div className='rel brand__row-move' key={i}>
              <ReactCursorPosition>
                <BrandImage cat={cat} />
              </ReactCursorPosition>
            </div>
          ))}
          {content.brandsCategories.map((cat, i) => (
            <div className='rel brand__row-move' key={i}>
              <ReactCursorPosition>
                <BrandImage cat={cat} />
              </ReactCursorPosition>
            </div>
          ))}
        </div>
      </div>
      <div className='brand__row rel f jcb aic'>
        <div className='brand__row-inner f jcb aic'>
          {content.brandsCategories.slice(0).reverse().map((cat, i) => (
            <div key={i}>
              <ReactCursorPosition>
                <BrandImage cat={cat} />
              </ReactCursorPosition>
            </div>
          ))}
          {content.brandsCategories.slice(0).reverse().map((cat, i) => (
            <div key={i}>
              <ReactCursorPosition>
                <BrandImage cat={cat} />
              </ReactCursorPosition>
            </div>
          ))}
        </div>
      </div>
      <div className='brand__row rel f jcb aic'>
        <div className='brand__row-inner f jcb aic'>
          {content.brandsCategories.map((cat, i) => (
            <div key={i}>
              <ReactCursorPosition>
                <BrandImage cat={cat} />
              </ReactCursorPosition>
            </div>
          ))}
          {content.brandsCategories.map((cat, i) => (
            <div key={i}>
              <ReactCursorPosition>
                <BrandImage cat={cat} />
              </ReactCursorPosition>
            </div>
          ))}
          {content.brandsCategories.map((cat, i) => (
            <div key={i}>
              <ReactCursorPosition>
                <BrandImage cat={cat} />
              </ReactCursorPosition>
            </div>
          ))}
        </div>
      </div>
      <div className='mt1 pt1 ac brand__button'>
        <PageLink to='/whats-in-store' className='button mb1 inline-block button__peach button__outline'>
          <span>See All Brands</span>
        </PageLink>
      </div>
    </div>
  )
}

export default BrandTicker